import { render, staticRenderFns } from "./InstallmentDetailTable.vue?vue&type=template&id=5b804626&lang=pug"
import script from "./InstallmentDetailTable.vue?vue&type=script&lang=js"
export * from "./InstallmentDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports